import React, { useCallback, useRef } from "react";
import { useState, useEffect } from "react";
import { Fragment } from "react";
import {
  getLocationList,
  reassignVendorManual,
} from "../../../Services/caseManagement.service";
import { getVendorList } from "../../../Services/approval.service";
import CommonButton from "../../../CommonComponents/CommonButton";
import CustomSelect from "../../../CommonComponents/Select/CustomSelect";
import CustomSwitch from "../../../CommonComponents/Switch/CustomSwitch";
import style from "./ManuallyAssignCase.module.css";
import useToaster from "../../../customHook/useToaster";
import MuiTab from "../../../CommonComponents/Tab/MuiTab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { stateShortFormObj } from "../../../Utils/helper";
import { putReassignVendorManual } from "../../../Services/approval.service";

let inputStyles = {
  height: "4.2rem",
  ".MuiOutlinedInput-root": {
    height: "3.9rem",
    backgroundColor: "#F5F5F5",
  },
};

let boxStyles = {
  marginBottom: "1rem",
};

let formStyles = {
  ".MuiAutocomplete-popper": {
    position: "relative !important",
    top: "-4rem !important",
  },
  ".MuiAutocomplete-listbox": {
    maxHeight: "15rem",
  },
};

function ManuallyAssignCase({
  caseId,
  data,
  onSubmit = () => {},
  isAllocatedCase,
}) {
  const [dropdownData, setDropdownData] = useState([]);
  const [vendorsList, setVendorsList] = useState([]);
  const [vendorsData, setVendorsData] = useState([]);
  const [isLocationSelectOpen, setIsLocationSelectOpen] = useState(false);
  const [vendorBlockActiveTabValue, setVendorBlockActiveTabValue] = useState(0);
  const { showToast } = useToaster();
  const locationRef = useRef(null);

  const locationDropdownStyle = {
    backgroundColor: "#F1F5F9",
    mb: "0.5rem",
  };

  const handleSubmit = () => {
    let isNoLocation = vendorsData?.find((obj) => !obj?.state || !obj?.city);
    let isNoVendor = vendorsData?.find((obj) => !obj?.vendor_employee_id);
    if (isNoLocation || isNoVendor) {
      let message = isNoLocation
        ? "Please provide vendor location for each vendor block."
        : "Please provide vendor name for each vendor block.";
      return showToast(message, "warning", true);
    }
    let payload = {
      ...data,
      case_allocation_id: data?.investigations?.[0]?.case_allocation_id || "",
      investigations: [...vendorsData],
    };
    if (isAllocatedCase) {
      reassignVendorManual(payload)
        ?.then((res) => {
          if (res?.success) {
            showToast(res?.data, "success", true);
            onSubmit("Allocated");
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    } else {
      putReassignVendorManual(payload)
        ?.then((response) => {
          if (response?.success) {
            showToast(response?.message, "success", true);
            onSubmit();
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    }
  };

  const switchHandler = (e) => {
    setVendorsData((prev) => {
      const updatedData = [...prev];
      let { isSpecialised } = updatedData[vendorBlockActiveTabValue];
      updatedData[vendorBlockActiveTabValue].isSpecialised = isSpecialised
        ? 0
        : 1;
      return updatedData;
    });
  };

  const stateChangeHandler = (e) => {
    setVendorsData((prev) => {
      let updatedData = [...prev];
      updatedData[vendorBlockActiveTabValue].state = e.target.outerText || "";
      updatedData[vendorBlockActiveTabValue].city = "";
      return updatedData;
    });
  };

  const cityChangeHandler = (e) => {
    setVendorsData((prev) => {
      let updatedData = [...prev];
      updatedData[vendorBlockActiveTabValue].city = e.target.outerText || "";
      return updatedData;
    });

    setVendorsListFunc(
      vendorsData[vendorBlockActiveTabValue]?.state,
      e?.target?.outerText
    );
  };

  const vendorListChangeHandler = (e, selected) => {
    setVendorsData((prev) => {
      let updatedData = [...prev];
      updatedData[vendorBlockActiveTabValue].vendor_employee_id =
        selected?.id || "";
      return updatedData;
    });
  };

  const setVendorsListFunc = (state, city) => {
    try {
      getVendorList(state, city, caseId)
        ?.then((response) => {
          if (response?.success) {
            setVendorsList([...response?.data]);
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    } catch (err) {
      showToast("Error while fetching vendor list", "error", true);
    }
  };

  const getVendorNameById = useCallback(
    (id) => {
      let selectedVendorObj = vendorsList?.find(
        (obj) => obj?.vendor_employee_id === id
      );
      return selectedVendorObj
        ? `${selectedVendorObj?.employee_name} / ${selectedVendorObj?.company_name}`
        : "";
    },
    [vendorsData, vendorsList]
  );

  useEffect(() => {
    try {
      getLocationList()
        ?.then((response) => {
          if (response?.success) {
            setDropdownData([...response?.data]);
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    } catch (err) {
      showToast("Error while fetching location list", "error", true);
    }
  }, []);

  useEffect(() => {
    if (data?.investigations?.length) {
      setVendorsData(data?.investigations);
      let { state = "", city = "" } =
        data?.investigations[vendorBlockActiveTabValue];
      if (state && city) setVendorsListFunc(state, city);
    }
  }, [data]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      let id = event?.target?.id;
      if (
        locationRef.current &&
        !locationRef.current.contains(event.target) &&
        id !== "location_div" &&
        id !== "location_h5"
      ) {
        setIsLocationSelectOpen(false);
      }
    };
    if (isLocationSelectOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isLocationSelectOpen, setIsLocationSelectOpen]);

  return (
    <Fragment>
      <h1 className={style.heading}>Manually Assign Case</h1>
      <div>
        <MuiTab
          tabs={vendorsData?.map((obj, idx) => ({
            label: `Vendor ${idx + 1}`,
          }))}
          variant="gray"
          fontSize="1.1rem"
          popupType="manual"
          activeTab={vendorBlockActiveTabValue}
          setActiveTab={setVendorBlockActiveTabValue}
        />

        <div className={style["small-navBar"]}>
          <div className={style["specialized-css-div"]}>
            <p
              className={style["specialized-css"]}
              style={{ width: "80px", fontSize: "1.4rem" }}
            >
              Specialized Vendor{" "}
            </p>
            <CustomSwitch
              checked={
                vendorsData[vendorBlockActiveTabValue]?.isSpecialised
                  ? true
                  : false
              }
              onChange={switchHandler}
            />
          </div>
          <div
            id="location_div"
            className={style["small-navBar-rightSide-element"]}
            onClick={() => setIsLocationSelectOpen((prev) => !prev)}
          >
            {vendorsData[vendorBlockActiveTabValue]?.state &&
            vendorsData[vendorBlockActiveTabValue]?.city ? (
              <h5
                className={style["location-css"]}
                id="location_h5"
              >{`${vendorsData[vendorBlockActiveTabValue]?.city
                .split("")
                .map((item, index) =>
                  index !== 0 ? item.toLowerCase() : item.toUpperCase()
                )
                .join("")}, ${
                stateShortFormObj[vendorsData[vendorBlockActiveTabValue]?.state]
              }`}</h5>
            ) : (
              <p>Location</p>
            )}
            {isLocationSelectOpen ? (
              <KeyboardArrowUpIcon
                sx={{ color: "#505050", fontSize: "2rem" }}
              />
            ) : (
              <KeyboardArrowDownIcon
                sx={{ color: "#505050", fontSize: "2rem" }}
              />
            )}
          </div>
          {isLocationSelectOpen && (
            <div
              className={style["location-dropdown-main-container"]}
              ref={locationRef}
            >
              <CustomSelect
                onChange={stateChangeHandler}
                searchable
                id="state"
                name="state"
                options={[...dropdownData?.map((obj) => obj?.state)]}
                value={vendorsData[vendorBlockActiveTabValue]?.state}
                sx={locationDropdownStyle}
                placeholder="Select State"
              />
              <CustomSelect
                disabled={
                  vendorsData[vendorBlockActiveTabValue]?.state.length === 0
                    ? true
                    : false
                }
                onChange={cityChangeHandler}
                searchable
                id="city"
                name="city"
                options={[
                  ...(dropdownData?.find(
                    (obj) =>
                      obj?.state?.toLowerCase() ==
                      vendorsData[
                        vendorBlockActiveTabValue
                      ]?.state?.toLowerCase()
                  )?.city || []),
                ]}
                value={vendorsData[vendorBlockActiveTabValue]?.city}
                sx={locationDropdownStyle}
                placeholder="Select City / District"
              />
            </div>
          )}
        </div>

        <CustomSelect
          label="Vendor / Vendor's Company name"
          placeholder="Enter"
          disabled={
            vendorsData[vendorBlockActiveTabValue]?.state &&
            vendorsData[vendorBlockActiveTabValue]?.city
              ? false
              : true
          }
          id="Vendor"
          name="Vendor"
          options={[
            ...vendorsList?.map((obj) => ({
              label: `${obj?.employee_name} / ${obj?.company_name}`,
              id: obj?.vendor_employee_id,
            })),
          ]}
          sx={inputStyles}
          boxStyles={boxStyles}
          formStyles={formStyles}
          searchable={true}
          value={getVendorNameById(
            vendorsData[vendorBlockActiveTabValue]?.vendor_employee_id
          )}
          onChange={vendorListChangeHandler}
        />

        <div className={style.button}>
          <CommonButton
            sx={{ width: "9.6rem", border: "unset" }}
            label={"Submit"}
            backgroundColor
            onClick={handleSubmit}
            fitContent={true}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default ManuallyAssignCase;
